/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";
import {
  LiteLLMRequestData,
  LiteLLMRequestData$Outbound,
  LiteLLMRequestData$outboundSchema,
} from "./litellmrequestdata.js";
import {
  LiteLLMStructuredMessage,
  LiteLLMStructuredMessage$Outbound,
  LiteLLMStructuredMessage$outboundSchema,
} from "./litellmstructuredmessage.js";

export const InputType = {
  Request: "request",
  Response: "response",
} as const;
export type InputType = ClosedEnum<typeof InputType>;

export type IngestRequestBody2 = {
  additionalProviderSpecificParams?: { [k: string]: any } | undefined;
  images?: Array<string> | undefined;
  inputType: InputType;
  litellmCallId?: string | undefined;
  litellmTraceId?: string | undefined;
  litellmVersion?: string | undefined;
  model?: string | undefined;
  /**
   * Sanitized metadata bound to the LiteLLM virtual key and request.
   */
  requestData: LiteLLMRequestData;
  requestHeaders?: { [k: string]: string } | undefined;
  structuredMessages?: Array<LiteLLMStructuredMessage> | undefined;
  texts?: Array<string> | undefined;
  toolCalls?: Array<any> | undefined;
  tools?: Array<any> | undefined;
};

/** @internal */
export const InputType$outboundSchema: z.ZodMiniEnum<typeof InputType> = z.enum(
  InputType,
);

/** @internal */
export type IngestRequestBody2$Outbound = {
  additional_provider_specific_params?: { [k: string]: any } | undefined;
  images?: Array<string> | undefined;
  input_type: string;
  litellm_call_id?: string | undefined;
  litellm_trace_id?: string | undefined;
  litellm_version?: string | undefined;
  model?: string | undefined;
  request_data: LiteLLMRequestData$Outbound;
  request_headers?: { [k: string]: string } | undefined;
  structured_messages?: Array<LiteLLMStructuredMessage$Outbound> | undefined;
  texts?: Array<string> | undefined;
  tool_calls?: Array<any> | undefined;
  tools?: Array<any> | undefined;
};

/** @internal */
export const IngestRequestBody2$outboundSchema: z.ZodMiniType<
  IngestRequestBody2$Outbound,
  IngestRequestBody2
> = z.pipe(
  z.object({
    additionalProviderSpecificParams: z.optional(z.record(z.string(), z.any())),
    images: z.optional(z.array(z.string())),
    inputType: InputType$outboundSchema,
    litellmCallId: z.optional(z.string()),
    litellmTraceId: z.optional(z.string()),
    litellmVersion: z.optional(z.string()),
    model: z.optional(z.string()),
    requestData: LiteLLMRequestData$outboundSchema,
    requestHeaders: z.optional(z.record(z.string(), z.string())),
    structuredMessages: z.optional(
      z.array(LiteLLMStructuredMessage$outboundSchema),
    ),
    texts: z.optional(z.array(z.string())),
    toolCalls: z.optional(z.array(z.any())),
    tools: z.optional(z.array(z.any())),
  }),
  z.transform((v) => {
    return remap$(v, {
      additionalProviderSpecificParams: "additional_provider_specific_params",
      inputType: "input_type",
      litellmCallId: "litellm_call_id",
      litellmTraceId: "litellm_trace_id",
      litellmVersion: "litellm_version",
      requestData: "request_data",
      requestHeaders: "request_headers",
      structuredMessages: "structured_messages",
      toolCalls: "tool_calls",
    });
  }),
);

export function ingestRequestBody2ToJSON(
  ingestRequestBody2: IngestRequestBody2,
): string {
  return JSON.stringify(
    IngestRequestBody2$outboundSchema.parse(ingestRequestBody2),
  );
}
